// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d4442e54","732":"6eca0fa8","977":"426d5afb"}[chunkId] + ".chunk.js";
};